var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _g3, _path8, _path9, _g4, _path0, _path1, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _g8, _path15, _g9, _g0, _path16, _path17, _g1, _path18, _path19, _g10, _path20, _g11, _path21, _g12, _g13, _path22, _path23, _g14, _path24, _path25, _g15, _path26, _g16, _path27, _g17, _path28, _g18, _path29, _g19, _g20, _path30, _g21, _path31, _g22, _g23, _path32, _path33, _g24, _path34, _g25, _path35, _g26, _g27, _path36, _path37, _g28, _path38, _g29, _path39, _g30, _g31, _path40, _path41, _g32, _path42, _g33, _path43, _g34, _path44, _g35, _g36, _path45, _g37, _path46, _g38, _g39, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g40, _path66, _path67, _g41, _path68, _g42, _path69, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZebraExcited(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_190528)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.566 320.001C217.278 320.001 260.82 314.111 260.82 306.845C260.82 299.579 217.278 293.689 163.566 293.689C109.855 293.689 66.3125 299.579 66.3125 306.845C66.3125 314.111 109.855 320.001 163.566 320.001Z",
    fill: "#F0BA9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2695 155.615C61.2695 155.615 89.9888 190.815 132.118 187.615L130.575 167.467C98.652 169.896 76.9939 142.874 76.9939 142.874L61.2695 155.615Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 142,
    width: 72,
    height: 46
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2695 155.615C61.2695 155.615 89.9888 190.815 132.118 187.615L130.575 167.467C98.652 169.896 76.9939 142.874 76.9939 142.874L61.2695 155.615Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9297 158.163C55.9297 158.163 80.0206 192.948 126.304 190.756L125.354 179.971C91.0574 182.341 65.7797 153.719 65.7797 153.719L55.9297 158.163Z",
    fill: "#D0D0D0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9802 156.148C47.2052 147.97 47.4426 127.111 61.2088 127.763C66.0151 128 71.5929 134.281 73.373 138.963C73.3136 137.067 74.085 132.444 76.8739 133.985C78.0013 134.578 79.2474 139.2 78.4166 144.593C74.7971 150.222 67.2612 156.148 61.9802 156.148Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 127,
    width: 29,
    height: 30
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9802 156.148C47.2052 147.97 47.4426 127.111 61.2088 127.763C66.0151 128 71.5929 134.281 73.373 138.963C73.3136 137.067 74.085 132.444 76.8739 133.985C78.0013 134.578 79.2474 139.2 78.4166 144.593C74.7971 150.222 67.2612 156.148 61.9802 156.148Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.728 158.578C70.4644 157.571 59.131 150.4 57.8256 146.963C53.5533 141.393 52.0699 133.274 62.2165 126.637C49.7557 125.274 44 135.289 44 135.289L59.9617 162.371L73.728 158.578Z",
    fill: "#0D0B0A"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M257.735 155.615C257.735 155.615 229.016 190.815 186.887 187.615L188.429 167.467C220.353 169.896 242.011 142.874 242.011 142.874L257.735 155.615Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 142,
    width: 72,
    height: 46
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.735 155.615C257.735 155.615 229.016 190.815 186.887 187.615L188.429 167.467C220.353 169.896 242.011 142.874 242.011 142.874L257.735 155.615Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M263.077 158.163C263.077 158.163 238.986 192.948 192.703 190.756L193.653 179.971C227.949 182.341 253.227 153.719 253.227 153.719L263.077 158.163Z",
    fill: "#D0D0D0"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.023 156.148C271.798 147.97 271.561 127.111 257.795 127.763C252.988 128 247.411 134.281 245.63 138.963C245.69 137.067 244.918 132.444 242.13 133.985C241.002 134.578 239.756 139.2 240.587 144.593C244.266 150.222 251.742 156.148 257.023 156.148Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 240,
    y: 127,
    width: 29,
    height: 30
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.023 156.148C271.798 147.97 271.561 127.111 257.795 127.763C252.988 128 247.411 134.281 245.63 138.963C245.69 137.067 244.918 132.444 242.13 133.985C241.002 134.578 239.756 139.2 240.587 144.593C244.266 150.222 251.742 156.148 257.023 156.148Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.273 158.577C248.537 157.57 259.87 150.4 261.176 146.963C265.448 141.392 266.932 133.274 256.785 126.637C269.246 125.214 275.001 135.288 275.001 135.288L259.04 162.37L245.273 158.577Z",
    fill: "#0D0B0A"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M227.353 254.163C221.953 254.992 214.477 252.859 207.593 247.703C202.372 243.733 197.506 237.985 194.124 230.281L187.359 233.659C191.632 242.548 197.565 249.007 203.855 253.392C212.518 259.378 221.775 261.333 228.302 260.089L227.353 254.163Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 230,
    width: 42,
    height: 31
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M227.353 254.163C221.953 254.992 214.477 252.859 207.593 247.703C202.372 243.733 197.506 237.985 194.124 230.281L187.359 233.659C191.632 242.548 197.565 249.007 203.855 253.392C212.518 259.378 221.775 261.333 228.302 260.089L227.353 254.163Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.8 237.629C192.402 240.355 195.013 242.844 197.208 245.036C203.32 251.081 210.381 255.466 218.51 257.481C220.706 258.014 222.96 258.666 225.215 258.725C225.393 258.725 225.868 259.318 225.987 259.436C226.699 260.029 227.411 260.503 228.182 260.918C230.437 262.162 232.87 262.755 235.421 262.636C240.88 262.459 245.39 259.318 248.95 255.17C250.137 253.807 251.264 252.384 252.392 250.903C252.807 250.31 253.282 249.659 253.697 249.066C253.757 249.007 254.053 248.533 254.172 248.651C254.409 248.947 253.875 249.955 253.757 250.251C253.104 251.97 252.332 253.57 251.442 255.17C247.763 261.688 241.948 266.607 234.531 267.259C231.208 267.555 227.826 267.021 224.8 265.659C223.198 264.947 221.774 263.703 220.172 263.051C217.323 261.984 214.238 261.866 211.39 260.74C202.43 257.125 193.945 250.192 189.02 241.54L190.8 237.629Z",
    fill: "#D0D0D0"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.033 263.704C223.676 265.186 219.166 257.6 224.328 252.8C228.838 248.593 237.501 254.46 241.121 245.097C242.248 246.341 242.07 249.304 240.587 251.497C240.587 251.497 241.952 250.667 242.664 248.652C242.96 250.193 242.782 251.911 241.358 254.341C241.358 254.341 242.664 253.689 243.613 253.986C239.163 255.467 239.697 261.986 231.033 263.704Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 245,
    width: 22,
    height: 19
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.033 263.704C223.676 265.186 219.166 257.6 224.328 252.8C228.838 248.593 237.501 254.46 241.121 245.097C242.248 246.341 242.07 249.304 240.587 251.497C240.587 251.497 241.952 250.667 242.664 248.652C242.96 250.193 242.782 251.911 241.358 254.341C241.358 254.341 242.664 253.689 243.613 253.986C239.163 255.467 239.697 261.986 231.033 263.704Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.512 260.386L221.597 257.897C226.641 261.749 234.651 259.616 238.39 254.816L236.076 255.468C239.458 252.801 241.297 249.364 242.009 247.053C242.425 245.69 245.391 256.356 244.501 257.423C240.941 262.045 235.72 265.245 229.726 265.008C227.056 264.89 224.386 264.179 222.072 262.816C220.767 262.164 218.512 260.386 218.512 260.386Z",
    fill: "#0D0B0A"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M152.528 305.837C152.528 305.837 151.876 268.859 158.403 250.015L119.418 236.622C111.348 260.148 111.289 306.192 111.289 306.192L152.528 305.837Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 236,
    width: 48,
    height: 71
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.528 305.837C152.528 305.837 151.876 268.859 158.403 250.015L119.418 236.622C111.348 260.148 111.289 306.192 111.289 306.192L152.528 305.837Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.273 306.133C116.51 293.926 117.756 260.148 124.343 241.126L157.631 252.563C157.868 251.674 158.165 250.844 158.461 250.015L119.477 236.622C111.407 260.148 111.348 306.192 111.348 306.192L116.273 306.133Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 236,
    width: 48,
    height: 71
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.528 305.837C152.528 305.837 151.876 268.859 158.403 250.015L119.418 236.622C111.348 260.148 111.289 306.192 111.289 306.192L152.528 305.837Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.577 272.829C102.092 273.363 95.3278 275.022 95.3871 276.563C95.5058 278.103 102.448 278.992 110.933 278.459C119.419 277.926 126.183 276.266 126.124 274.726C126.005 273.126 119.063 272.296 110.577 272.829ZM112.654 259.792C104.525 257.363 97.5826 256.533 97.1079 258.074C96.6332 259.555 102.864 262.755 110.993 265.244C119.122 267.674 126.064 268.503 126.539 266.963C127.014 265.481 120.783 262.222 112.654 259.792Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 257,
    width: 16,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 257,
    width: 32,
    height: 22
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M110.577 272.829C102.092 273.363 95.3278 275.022 95.3871 276.563C95.5058 278.103 102.448 278.992 110.933 278.459C119.419 277.926 126.183 276.266 126.124 274.726C126.005 273.126 119.063 272.296 110.577 272.829ZM112.654 259.792C104.525 257.363 97.5826 256.533 97.1079 258.074C96.6332 259.555 102.864 262.755 110.993 265.244C119.122 267.674 126.064 268.503 126.539 266.963C127.014 265.481 120.783 262.222 112.654 259.792Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.528 305.837C152.528 305.837 151.876 268.859 158.403 250.015L119.418 236.622C111.348 260.148 111.289 306.192 111.289 306.192L152.528 305.837Z",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.273 306.133C116.51 293.926 117.756 260.148 124.343 241.126L157.631 252.563C157.868 251.674 158.165 250.844 158.461 250.015L119.477 236.622C111.407 260.148 111.348 306.192 111.348 306.192L116.273 306.133Z",
    fill: "#666460"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.941 306.963C111.169 306.963 110.457 306.548 110.042 305.897C109.627 305.245 109.627 304.415 109.983 303.704C113.662 297.245 123.512 292.504 133.54 292.504C143.864 292.504 151.281 297.482 154.011 304.237C154.248 304.83 154.189 305.541 153.833 306.074C153.477 306.608 152.884 306.904 152.231 306.904C144.22 306.963 120.545 306.963 111.941 306.963Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 292,
    width: 46,
    height: 15
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.941 306.963C111.169 306.963 110.457 306.548 110.042 305.897C109.627 305.245 109.627 304.415 109.983 303.704C113.662 297.245 123.512 292.504 133.54 292.504C143.864 292.504 151.281 297.482 154.011 304.237C154.248 304.83 154.189 305.541 153.833 306.074C153.477 306.608 152.884 306.904 152.231 306.904C144.22 306.963 120.545 306.963 111.941 306.963Z",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.381 301.689C108.915 302.519 109.865 303.052 110.933 303.052C121.02 303.052 144.577 303.052 153.774 302.993C154.605 302.993 155.376 302.638 155.851 301.986C156.148 302.401 156.385 302.815 156.623 303.23C157.038 304.001 157.038 304.949 156.563 305.719C156.089 306.489 155.258 306.964 154.308 306.964C144.874 307.023 120.545 307.023 110.221 307.023C109.093 307.023 108.025 306.371 107.551 305.423C107.017 304.415 107.135 303.289 107.847 302.401C107.966 302.104 108.144 301.926 108.381 301.689Z",
    fill: "#0D0B0A"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.601 305.837C174.601 305.837 175.254 268.859 168.727 250.015L207.711 236.622C215.781 260.148 215.84 306.192 215.84 306.192L174.601 305.837Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 236,
    width: 48,
    height: 71
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.601 305.837C174.601 305.837 175.254 268.859 168.727 250.015L207.711 236.622C215.781 260.148 215.84 306.192 215.84 306.192L174.601 305.837Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.915 306.133C210.678 293.926 209.432 260.148 202.846 241.126L169.557 252.563C169.32 251.674 169.023 250.844 168.727 250.015L207.711 236.622C215.781 260.148 215.84 306.192 215.84 306.192L210.915 306.133Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 168,
    y: 236,
    width: 48,
    height: 71
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M174.601 305.837C174.601 305.837 175.254 268.859 168.727 250.015L207.711 236.622C215.781 260.148 215.84 306.192 215.84 306.192L174.601 305.837Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.612 272.829C225.097 273.363 231.862 275.022 231.802 276.563C231.684 278.103 224.741 278.992 216.256 278.459C207.771 277.926 201.006 276.266 201.066 274.726C201.184 273.126 208.127 272.296 216.612 272.829ZM214.535 259.792C222.665 257.363 229.607 256.533 230.082 258.074C230.556 259.555 224.326 262.755 216.197 265.244C208.068 267.674 201.125 268.503 200.65 266.963C200.176 265.481 206.406 262.222 214.535 259.792Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 257,
    width: 16,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 200,
    y: 257,
    width: 32,
    height: 22
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M216.612 272.829C225.097 273.363 231.862 275.022 231.802 276.563C231.684 278.103 224.741 278.992 216.256 278.459C207.771 277.926 201.006 276.266 201.066 274.726C201.184 273.126 208.127 272.296 216.612 272.829ZM214.535 259.792C222.665 257.363 229.607 256.533 230.082 258.074C230.556 259.555 224.326 262.755 216.197 265.244C208.068 267.674 201.125 268.503 200.65 266.963C200.176 265.481 206.406 262.222 214.535 259.792Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.601 305.837C174.601 305.837 175.254 268.859 168.727 250.015L207.711 236.622C215.781 260.148 215.84 306.192 215.84 306.192L174.601 305.837Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.915 306.133C210.678 293.926 209.432 260.148 202.846 241.126L169.557 252.563C169.32 251.674 169.023 250.844 168.727 250.015L207.711 236.622C215.781 260.148 215.84 306.192 215.84 306.192L210.915 306.133Z",
    fill: "#0D0B0A"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M215.248 306.963C216.019 306.963 216.731 306.548 217.146 305.897C217.562 305.245 217.562 304.415 217.206 303.704C213.527 297.245 203.677 292.504 193.649 292.504C183.324 292.504 175.907 297.482 173.178 304.237C172.94 304.83 173 305.541 173.356 306.074C173.712 306.608 174.305 306.904 174.958 306.904C182.909 306.963 206.584 306.963 215.248 306.963Z",
    fill: "#2F2D2A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 292,
    width: 45,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.248 306.963C216.019 306.963 216.731 306.548 217.146 305.897C217.562 305.245 217.562 304.415 217.206 303.704C213.527 297.245 203.677 292.504 193.649 292.504C183.324 292.504 175.907 297.482 173.178 304.237C172.94 304.83 173 305.541 173.356 306.074C173.712 306.608 174.305 306.904 174.958 306.904C182.909 306.963 206.584 306.963 215.248 306.963Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.749 301.689C218.215 302.519 217.265 303.052 216.197 303.052C206.11 303.052 182.553 303.052 173.356 302.993C172.525 302.993 171.754 302.638 171.279 301.986C170.982 302.401 170.745 302.815 170.508 303.23C170.092 304.001 170.092 304.949 170.567 305.719C171.042 306.489 171.872 306.964 172.822 306.964C182.256 307.023 206.585 307.023 216.909 307.023C218.037 307.023 219.105 306.371 219.58 305.423C220.114 304.415 219.995 303.289 219.283 302.401C219.164 302.104 218.986 301.926 218.749 301.689Z",
    fill: "#0D0B0A"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.926H130.575C122.98 183.526 117.105 208.948 117.105 226.252C117.105 256.711 137.814 272.592 163.448 272.592C189.082 272.592 209.968 256.77 209.968 226.252C210.028 209.007 204.153 183.585 196.558 157.926Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 157,
    width: 93,
    height: 116
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.926H130.575C122.98 183.526 117.105 208.948 117.105 226.252C117.105 256.711 137.814 272.592 163.448 272.592C189.082 272.592 209.968 256.77 209.968 226.252C210.028 209.007 204.153 183.585 196.558 157.926Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.271 157.926H130.575C122.98 183.526 117.105 208.948 117.105 226.252C117.105 239.763 121.2 252.148 128.024 261.748C124.167 253.096 121.971 243.141 121.971 232.533C122.03 215.348 127.608 184.652 136.271 157.926Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 157,
    width: 93,
    height: 116
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.926H130.575C122.98 183.526 117.105 208.948 117.105 226.252C117.105 256.711 137.814 272.592 163.448 272.592C189.082 272.592 209.968 256.77 209.968 226.252C210.028 209.007 204.153 183.585 196.558 157.926Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.863 157.926H196.56C204.155 183.526 210.029 208.948 210.029 226.252C210.029 239.763 205.935 252.148 199.111 261.748C202.968 253.096 205.164 243.141 205.164 232.533C205.164 215.348 199.586 184.652 190.863 157.926Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 157,
    width: 93,
    height: 116
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.926H130.575C122.98 183.526 117.105 208.948 117.105 226.252C117.105 256.711 137.814 272.592 163.448 272.592C189.082 272.592 209.968 256.77 209.968 226.252C210.028 209.007 204.153 183.585 196.558 157.926Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.452 144.178C182.14 163.378 189.141 202.43 189.141 215.644C189.141 234.904 178.401 246.933 163.626 246.933C148.851 246.933 137.637 234.904 137.637 215.644C137.637 202.43 144.579 163.378 149.267 144.178H177.452Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 157,
    width: 93,
    height: 116
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.926H130.575C122.98 183.526 117.105 208.948 117.105 226.252C117.105 256.711 137.814 272.592 163.448 272.592C189.082 272.592 209.968 256.77 209.968 226.252C210.028 209.007 204.153 183.585 196.558 157.926Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.876 214.34C222.489 215.525 230.143 217.777 229.906 219.377C229.728 220.977 221.777 221.333 212.164 220.088C202.551 218.903 194.897 216.651 195.134 215.051C195.312 213.451 203.263 213.155 212.876 214.34ZM212.401 201.422C222.073 200.711 229.965 201.422 230.084 203.022C230.203 204.622 222.489 206.518 212.817 207.229C203.145 207.94 195.253 207.229 195.134 205.629C195.016 204.088 202.729 202.192 212.401 201.422ZM211.274 187.555C220.709 185.422 228.66 185.007 229.016 186.548C229.372 188.088 222.014 191.111 212.52 193.244C203.085 195.377 195.134 195.792 194.778 194.251C194.482 192.651 201.839 189.688 211.274 187.555Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 185,
    width: 16,
    height: 36
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 185,
    width: 37,
    height: 36
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M212.876 214.341C222.489 215.526 230.143 217.778 229.906 219.378C229.728 220.978 221.777 221.334 212.164 220.089C202.551 218.904 194.897 216.652 195.134 215.052C195.312 213.452 203.263 213.156 212.876 214.341ZM212.401 201.423C222.073 200.711 229.965 201.423 230.084 203.023C230.203 204.623 222.489 206.519 212.817 207.23C203.145 207.941 195.253 207.23 195.134 205.63C195.016 204.089 202.729 202.193 212.401 201.423ZM211.274 187.556C220.709 185.423 228.66 185.008 229.016 186.549C229.372 188.089 222.014 191.111 212.52 193.245C203.085 195.378 195.134 195.793 194.778 194.252C194.482 192.652 201.839 189.689 211.274 187.556Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.927H130.575C122.98 183.527 117.105 208.949 117.105 226.253C117.105 256.712 137.814 272.593 163.448 272.593C189.082 272.593 209.968 256.771 209.968 226.253C210.028 209.008 204.153 183.586 196.558 157.927Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.863 157.927H196.56C204.155 183.527 210.029 208.949 210.029 226.253C210.029 239.764 205.935 252.149 199.111 261.749C202.968 253.097 205.164 243.142 205.164 232.534C205.164 215.349 199.586 184.653 190.863 157.927Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 157,
    width: 93,
    height: 116
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.926H130.575C122.98 183.526 117.105 208.948 117.105 226.252C117.105 256.711 137.814 272.592 163.448 272.592C189.082 272.592 209.968 256.77 209.968 226.252C210.028 209.007 204.153 183.585 196.558 157.926Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.783 214.34C104.17 215.525 96.5155 217.777 96.7528 219.377C96.9309 220.977 104.882 221.333 114.495 220.088C124.107 218.903 131.762 216.651 131.524 215.051C131.406 213.451 123.395 213.155 113.783 214.34ZM114.317 201.422C104.645 200.711 96.7528 201.422 96.6342 203.022C96.5155 204.622 104.229 206.518 113.901 207.229C123.573 207.94 131.465 207.229 131.584 205.629C131.702 204.088 123.989 202.192 114.317 201.422ZM115.385 187.555C105.95 185.422 97.9989 185.007 97.6429 186.548C97.2869 188.088 104.645 191.111 114.139 193.244C123.573 195.377 131.524 195.792 131.881 194.251C132.237 192.651 124.819 189.688 115.385 187.555Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 117,
    y: 185,
    width: 15,
    height: 36
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 185,
    width: 36,
    height: 36
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M113.783 214.341C104.17 215.526 96.5155 217.778 96.7528 219.378C96.9309 220.978 104.882 221.334 114.495 220.089C124.107 218.904 131.762 216.652 131.524 215.052C131.406 213.452 123.395 213.156 113.783 214.341ZM114.317 201.423C104.645 200.711 96.7528 201.423 96.6342 203.023C96.5155 204.623 104.229 206.519 113.901 207.23C123.573 207.941 131.465 207.23 131.584 205.63C131.702 204.089 123.989 202.193 114.317 201.423ZM115.385 187.556C105.95 185.423 97.9989 185.008 97.6429 186.549C97.2869 188.089 104.645 191.111 114.139 193.245C123.573 195.378 131.524 195.793 131.881 194.252C132.237 192.652 124.819 189.689 115.385 187.556Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.558 157.927H130.575C122.98 183.527 117.105 208.949 117.105 226.253C117.105 256.712 137.814 272.593 163.448 272.593C189.082 272.593 209.968 256.771 209.968 226.253C210.028 209.008 204.153 183.586 196.558 157.927Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.271 157.927H130.575C122.98 183.527 117.105 208.949 117.105 226.253C117.105 239.764 121.2 252.149 128.024 261.749C124.167 253.097 121.971 243.142 121.971 232.534C122.03 215.349 127.608 184.653 136.271 157.927Z",
    fill: "#666460"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M239.934 24.1775C241.18 24.4145 242.07 25.5997 241.951 26.8442C240.349 44.9182 221.599 60.859 203.679 58.5479L197.508 51.5553C201.365 30.8145 221.777 20.5034 239.934 24.1775Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 23,
    width: 45,
    height: 36
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M239.934 24.1775C241.18 24.4145 242.07 25.5997 241.951 26.8442C240.349 44.9182 221.599 60.859 203.679 58.5479L197.508 51.5553C201.365 30.8145 221.777 20.5034 239.934 24.1775Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.398 45.5111L202.611 40C202.611 40 209.198 42.963 216.912 50.6074C218.276 51.9704 220.413 52.2667 222.133 51.3778C227.948 48.1778 240.291 39.763 243.91 24C243.91 24 243.791 52.6222 214.004 62.3407C214.004 62.4 210.919 52.8 198.398 45.5111Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 197,
    y: 23,
    width: 45,
    height: 36
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M239.934 24.1775C241.18 24.4145 242.07 25.5997 241.951 26.8442C240.349 44.9182 221.599 60.859 203.679 58.5479L197.508 51.5553C201.365 30.8145 221.777 20.5034 239.934 24.1775Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.078 49.8365C202.078 49.8365 209.199 32.8883 230.145 33.8957C230.619 33.8957 231.035 34.1328 231.331 34.4883C231.628 34.8439 231.687 35.318 231.569 35.792C230.204 40.4143 225.16 52.5031 208.665 54.5772L202.078 49.8365Z",
    fill: "#F7D8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 33,
    width: 30,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 202,
    y: 33,
    width: 30,
    height: 22
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M202.074 49.8375C202.074 49.8375 209.195 32.8893 230.141 33.8967C230.615 33.8967 231.031 34.1337 231.328 34.4893C231.624 34.8449 231.684 35.3189 231.565 35.793C230.2 40.4152 225.156 52.5041 208.661 54.5782L202.074 49.8375Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.93 24.1785C241.176 24.4155 242.066 25.6007 241.948 26.8451C240.345 44.9192 221.595 60.86 203.675 58.5488L197.504 51.5563C201.361 30.8155 221.773 20.5044 239.93 24.1785Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.395 45.5111L202.607 40C202.607 40 209.194 42.963 216.908 50.6074C218.273 51.9704 220.409 52.2667 222.129 51.3778C227.944 48.1778 240.287 39.763 243.906 24C243.906 24 243.788 52.6222 214 62.3407C214 62.4 210.915 52.8 198.395 45.5111Z",
    fill: "#F0BA9E"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 24.1775C85.9539 24.4145 85.0638 25.5997 85.1825 26.8442C86.7846 44.9182 105.535 60.859 123.455 58.5479L129.626 51.5553C125.769 30.8145 105.416 20.5034 87.2 24.1775Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 23,
    width: 45,
    height: 36
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 24.1775C85.9539 24.4145 85.0638 25.5997 85.1825 26.8442C86.7846 44.9182 105.535 60.859 123.455 58.5479L129.626 51.5553C125.769 30.8145 105.416 20.5034 87.2 24.1775Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.734 45.5111L124.521 40C124.521 40 117.935 42.963 110.221 50.6074C108.856 51.9704 106.72 52.2667 104.999 51.3778C99.1844 48.1778 86.8422 39.763 83.2227 24C83.2227 24 83.3413 52.6222 113.129 62.3407C113.129 62.4 116.214 52.8 128.734 45.5111Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 23,
    width: 45,
    height: 36
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 24.1775C85.9539 24.4145 85.0638 25.5997 85.1825 26.8442C86.7846 44.9182 105.535 60.859 123.455 58.5479L129.626 51.5553C125.769 30.8145 105.416 20.5034 87.2 24.1775Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.056 49.8365C125.056 49.8365 117.935 32.8883 96.9892 33.8957C96.5145 33.8957 96.0992 34.1328 95.8025 34.4883C95.5058 34.8439 95.4464 35.318 95.5651 35.792C96.9299 40.4143 101.974 52.5031 118.469 54.5772L125.056 49.8365Z",
    fill: "#F7D8C6"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 33,
    width: 31,
    height: 22
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 33,
    width: 31,
    height: 22
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M125.056 49.8375C125.056 49.8375 117.935 32.8893 96.9892 33.8967C96.5145 33.8967 96.0992 34.1337 95.8025 34.4893C95.5058 34.8449 95.4464 35.3189 95.5651 35.793C96.9299 40.4152 101.974 52.5041 118.469 54.5782L125.056 49.8375Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.2 24.1785C85.9539 24.4155 85.0638 25.6007 85.1825 26.8451C86.7846 44.9192 105.535 60.86 123.455 58.5488L129.626 51.5563C125.769 30.8155 105.416 20.5044 87.2 24.1785Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.734 45.5111L124.521 40C124.521 40 117.935 42.963 110.221 50.6074C108.856 51.9704 106.72 52.2667 104.999 51.3778C99.1844 48.1778 86.8422 39.763 83.2227 24C83.2227 24 83.3413 52.6222 113.129 62.3407C113.129 62.4 116.214 52.8 128.734 45.5111Z",
    fill: "#F0BA9E"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M163.328 178.252C140.364 177.659 107.491 165.63 99.1841 112.237C93.5471 76.3851 107.788 46.7555 135.024 33.7777C157.631 22.8148 180.536 26.3111 193.827 34.6073C219.936 47.9999 233.464 77.0962 228.005 112.237C219.639 165.807 186.529 177.718 163.565 178.252H163.328Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 26,
    width: 133,
    height: 153
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M163.328 178.252C140.364 177.659 107.491 165.63 99.1841 112.237C93.5471 76.3851 107.788 46.7555 135.024 33.7777C157.631 22.8148 180.536 26.3111 193.827 34.6073C219.936 47.9999 233.464 77.0962 228.005 112.237C219.639 165.807 186.529 177.718 163.565 178.252H163.328Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.508 69.8669C108.382 53.8077 119.597 41.1262 135.025 33.8373C157.632 22.8743 180.536 26.3706 193.828 34.6669C208.366 42.1336 218.928 54.4003 224.565 69.8669C218.512 56.1188 208.188 45.1558 194.54 38.341C180.892 30.0447 157.454 26.5484 134.253 37.5114C119.775 44.2077 108.857 55.5262 102.508 69.8669Z",
    fill: "#F0F0F0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 26,
    width: 133,
    height: 153
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M163.328 178.252C140.364 177.659 107.491 165.63 99.1841 112.237C93.5471 76.3851 107.788 46.7555 135.024 33.7777C157.631 22.8148 180.536 26.3111 193.827 34.6073C219.936 47.9999 233.464 77.0962 228.005 112.237C219.639 165.807 186.529 177.718 163.565 178.252H163.328Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4802 80.9482C98.3528 89.3038 98.4122 98.3112 99.8956 107.793C108.084 161.185 140.601 173.156 163.327 173.807H163.564C186.291 173.274 219.045 161.363 227.293 107.793C228.717 98.3705 228.835 89.3631 227.708 80.9482C229.607 90.5482 229.785 101.096 228.005 112.237C219.638 165.807 186.528 177.719 163.564 178.252H163.268C140.304 177.659 107.431 165.63 99.1242 112.237C97.4034 101.096 97.5814 90.6075 99.4802 80.9482Z",
    fill: "#D0D0D0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 26,
    width: 133,
    height: 153
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M163.328 178.252C140.364 177.659 107.491 165.63 99.1841 112.237C93.5471 76.3851 107.788 46.7555 135.024 33.7777C157.631 22.8148 180.536 26.3111 193.827 34.6073C219.936 47.9999 233.464 77.0962 228.005 112.237C219.639 165.807 186.529 177.718 163.565 178.252H163.328Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.405 148.503C239.871 149.57 232.098 146.844 222.96 142.459C213.822 138.074 206.82 133.629 207.354 132.622C207.889 131.555 215.662 134.281 224.8 138.666C233.938 143.052 240.88 147.437 240.405 148.503ZM86.7812 148.503C87.3152 149.57 95.0884 146.844 104.226 142.459C113.364 138.074 120.366 133.629 119.832 132.622C119.298 131.555 111.525 134.281 102.387 138.666C93.2489 142.992 86.2471 147.437 86.7812 148.503ZM242.66 142.518C242.067 143.703 233.404 140.681 223.316 135.822C213.229 130.963 205.456 126.044 205.99 124.859C206.583 123.674 215.246 126.696 225.334 131.555C235.48 136.474 243.254 141.333 242.66 142.518ZM84.467 142.518C85.0604 143.703 93.7236 140.681 103.811 135.822C113.898 130.963 121.671 126.044 121.137 124.859C120.544 123.674 111.881 126.696 101.794 131.555C91.6468 136.474 83.8736 141.333 84.467 142.518ZM247.466 137.718C246.932 138.785 239.159 136.059 230.021 131.674C220.883 127.289 213.882 122.844 214.416 121.837C214.95 120.77 222.723 123.496 231.861 127.881C240.939 132.207 247.941 136.652 247.466 137.718ZM79.72 137.718C80.2541 138.785 88.0273 136.059 97.1652 131.674C106.303 127.289 113.305 122.844 112.771 121.837C112.237 120.77 104.464 123.496 95.3257 127.881C86.1878 132.207 79.186 136.652 79.72 137.718Z",
    fill: "#2F2D2A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 121,
    width: 133,
    height: 28
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 121,
    width: 169,
    height: 28
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M240.409 148.503C239.875 149.57 232.102 146.844 222.964 142.459C213.826 138.074 206.824 133.629 207.358 132.622C207.892 131.555 215.666 134.281 224.804 138.666C233.942 143.052 240.884 147.437 240.409 148.503ZM86.7851 148.503C87.3191 149.57 95.0923 146.844 104.23 142.459C113.368 138.074 120.37 133.629 119.836 132.622C119.302 131.555 111.529 134.281 102.391 138.666C93.2528 142.992 86.251 147.437 86.7851 148.503ZM242.664 142.518C242.071 143.703 233.407 140.681 223.32 135.822C213.233 130.963 205.46 126.044 205.994 124.859C206.587 123.674 215.25 126.696 225.338 131.555C235.484 136.474 243.257 141.333 242.664 142.518ZM84.4709 142.518C85.0643 143.703 93.7275 140.681 103.815 135.822C113.902 130.963 121.675 126.044 121.141 124.859C120.548 123.674 111.885 126.696 101.797 131.555C91.6507 136.474 83.8775 141.333 84.4709 142.518ZM247.47 137.718C246.936 138.785 239.163 136.059 230.025 131.674C220.887 127.289 213.886 122.844 214.42 121.837C214.954 120.77 222.727 123.496 231.865 127.881C240.943 132.207 247.945 136.652 247.47 137.718ZM79.7239 137.718C80.258 138.785 88.0312 136.059 97.1691 131.674C106.307 127.289 113.309 122.844 112.775 121.837C112.241 120.77 104.468 123.496 95.3296 127.881C86.1917 132.207 79.1899 136.652 79.7239 137.718Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.332 178.252C140.368 177.659 107.495 165.63 99.1881 112.237C93.551 76.3851 107.792 46.7555 135.028 33.7777C157.635 22.8148 180.539 26.3111 193.831 34.6073C219.939 47.9999 233.468 77.0962 228.009 112.237C219.643 165.807 186.533 177.718 163.569 178.252H163.332Z",
    fill: "white"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4841 80.9482C98.3567 89.3038 98.4161 98.3112 99.8995 107.793C108.088 161.185 140.605 173.156 163.331 173.807H163.568C186.295 173.274 219.049 161.363 227.297 107.793C228.721 98.3705 228.839 89.3631 227.712 80.9482C229.611 90.5482 229.789 101.096 228.009 112.237C219.642 165.807 186.532 177.719 163.568 178.252H163.272C140.308 177.659 107.435 165.63 99.1281 112.237C97.4073 101.096 97.5853 90.6075 99.4841 80.9482Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 26,
    width: 133,
    height: 153
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M163.328 178.252C140.364 177.659 107.491 165.63 99.1841 112.237C93.5471 76.3851 107.788 46.7555 135.024 33.7777C157.631 22.8148 180.536 26.3111 193.827 34.6073C219.936 47.9999 233.464 77.0962 228.005 112.237C219.639 165.807 186.529 177.718 163.565 178.252H163.328Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.06 25.3033C215.247 26.1329 211.449 33.3033 205.575 41.244C199.701 49.1847 194.004 54.9329 192.877 54.044C191.69 53.2144 195.488 46.044 201.362 38.1033C207.177 30.2218 212.874 24.4736 214.06 25.3033ZM113.128 25.3033C111.941 26.1329 115.738 33.3033 121.613 41.244C127.487 49.1847 133.184 54.9329 134.311 54.044C135.498 53.2144 131.7 46.044 125.826 38.1033C119.951 30.2218 114.255 24.4736 113.128 25.3033ZM222.011 35.9699C222.724 36.9181 218.273 41.6588 211.983 46.5773C205.694 51.4959 199.997 54.7551 199.285 53.807C198.573 52.8588 203.024 48.1181 209.313 43.1996C215.544 38.2218 221.24 35.0218 222.011 35.9699ZM105.176 35.9699C104.464 36.9181 108.915 41.6588 115.204 46.5773C121.494 51.4959 127.19 54.7551 127.903 53.807C128.615 52.8588 124.164 48.1181 117.875 43.1996C111.585 38.2218 105.888 35.0218 105.176 35.9699ZM199.701 21.8662C200.828 22.281 199.582 28.681 196.912 36.207C194.242 43.7329 191.215 49.481 190.029 49.1255C188.901 48.7107 190.147 42.3107 192.818 34.7847C195.488 27.2588 198.573 21.5107 199.701 21.8662ZM127.428 21.8662C126.3 22.281 127.547 28.681 130.217 36.207C132.887 43.7329 135.913 49.481 137.1 49.1255C138.227 48.7107 136.981 42.3107 134.311 34.7847C131.641 27.2588 128.555 21.5107 127.428 21.8662Z",
    fill: "#0D0B0A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 26,
    width: 118,
    height: 29
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 21,
    width: 118,
    height: 34
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M214.06 25.3042C215.247 26.1339 211.449 33.3042 205.575 41.245C199.701 49.1857 194.004 54.9339 192.877 54.045C191.69 53.2154 195.488 46.045 201.362 38.1042C207.177 30.2228 212.874 24.4746 214.06 25.3042ZM113.128 25.3042C111.941 26.1339 115.738 33.3042 121.613 41.245C127.487 49.1857 133.184 54.9339 134.311 54.045C135.498 53.2154 131.7 46.045 125.826 38.1042C119.951 30.2228 114.255 24.4746 113.128 25.3042ZM222.011 35.9709C222.724 36.9191 218.273 41.6598 211.983 46.5783C205.694 51.4968 199.997 54.7561 199.285 53.8079C198.573 52.8598 203.024 48.1191 209.313 43.2005C215.544 38.2228 221.24 35.0228 222.011 35.9709ZM105.176 35.9709C104.464 36.9191 108.915 41.6598 115.204 46.5783C121.494 51.4968 127.19 54.7561 127.903 53.8079C128.615 52.8598 124.164 48.1191 117.875 43.2005C111.585 38.2228 105.888 35.0228 105.176 35.9709ZM199.701 21.8672C200.828 22.282 199.582 28.682 196.912 36.2079C194.242 43.7339 191.215 49.482 190.029 49.1265C188.901 48.7117 190.147 42.3116 192.818 34.7857C195.488 27.2598 198.573 21.5116 199.701 21.8672ZM127.428 21.8672C126.3 22.282 127.547 28.682 130.217 36.2079C132.887 43.7339 135.913 49.482 137.1 49.1265C138.227 48.7117 136.981 42.3116 134.311 34.7857C131.641 27.2598 128.555 21.5116 127.428 21.8672Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.328 178.253C140.364 177.66 107.491 165.631 99.1841 112.238C93.5471 76.3861 107.788 46.7565 135.024 33.7787C157.631 22.8157 180.536 26.312 193.827 34.6083C219.936 48.0009 233.464 77.0972 228.005 112.238C219.639 165.808 186.529 177.719 163.565 178.253H163.328Z",
    fill: "white"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.508 69.8669C108.382 53.8077 119.597 41.1262 135.025 33.8373C157.632 22.8743 180.536 26.3706 193.828 34.6669C208.366 42.1336 218.928 54.4003 224.565 69.8669C218.512 56.1188 208.188 45.1558 194.54 38.341C180.892 30.0447 157.454 26.5484 134.253 37.5114C119.775 44.2077 108.857 55.5262 102.508 69.8669Z",
    fill: "#666460"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.564 117.748C187.536 117.748 206.999 132.918 206.999 151.585C206.999 170.252 191.215 185.422 163.564 185.422C135.913 185.422 120.129 170.252 120.129 151.585C120.188 132.918 139.592 117.748 163.564 117.748Z",
    fill: "#9A9895"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.41 135.467C132.768 124.918 147.128 117.748 163.623 117.748C180.119 117.748 194.479 124.918 201.837 135.467C193.233 127.052 179.348 121.541 163.623 121.541C147.899 121.6 133.955 127.052 125.41 135.467Z",
    fill: "#C1BFBD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.309 154.607C124.7 168.948 139.89 179.496 163.565 179.496C187.241 179.496 202.431 168.948 206.822 154.607C205.22 171.911 189.674 185.482 163.565 185.482C137.457 185.422 121.911 171.852 120.309 154.607Z",
    fill: "#64615E"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.029 119.822C193.47 120.948 195.191 124.622 193.886 128.118C192.58 131.614 188.723 133.57 185.282 132.444C181.84 131.318 180.119 127.644 181.425 124.148C182.73 120.652 186.587 118.755 190.029 119.822Z",
    fill: "#9A9895"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.605 123.437C190.623 124.089 191.631 126.282 190.919 128.296C190.148 130.311 187.359 132.385 184.986 131.556C185.994 129.126 183.68 129.304 184.155 126.459C184.452 124.326 186.588 122.785 188.605 123.437Z",
    fill: "#2F2D2A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.102 119.822C133.66 120.948 131.94 124.622 133.245 128.118C134.55 131.614 138.407 133.57 141.849 132.444C145.291 131.318 147.011 127.644 145.706 124.148C144.4 120.652 140.544 118.755 137.102 119.822Z",
    fill: "#9A9895"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.526 123.437C136.509 124.089 135.5 126.282 136.212 128.296C136.983 130.311 139.772 132.385 142.146 131.556C141.137 129.126 143.451 129.304 142.977 126.459C142.68 124.326 140.603 122.785 138.526 123.437Z",
    fill: "#2F2D2A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.644 72.0596C147.604 72.0596 154.843 79.4077 154.843 88.4744C154.843 97.5411 147.604 104.889 138.644 104.889C129.684 104.889 122.445 97.5411 122.445 88.4744C122.445 79.4077 129.684 72.0596 138.644 72.0596Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.644 77.6895C145.171 77.6895 150.452 83.0228 150.452 89.6006C150.452 96.1783 145.171 101.512 138.644 101.512C132.117 101.512 126.836 96.1783 126.836 89.6006C126.836 83.0228 132.117 77.6895 138.644 77.6895Z",
    fill: "#0D0B0A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.076 81.1851C141.966 80.5333 143.746 81.4814 145.111 83.3185C146.475 85.1555 146.891 87.1703 146.001 87.8222C145.111 88.474 143.331 87.5259 141.966 85.6888C140.601 83.9111 140.186 81.837 141.076 81.1851Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.3 89.8369C147.308 89.8369 148.08 90.6665 148.08 91.6147C148.08 92.5628 147.308 93.3925 146.3 93.3925C145.291 93.3925 144.52 92.5628 144.52 91.6147C144.52 90.6665 145.291 89.8369 146.3 89.8369Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.547 72.0596C197.507 72.0596 204.746 79.4077 204.746 88.4744C204.746 97.5411 197.507 104.889 188.547 104.889C179.587 104.889 172.348 97.5411 172.348 88.4744C172.348 79.4077 179.587 72.0596 188.547 72.0596Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.546 77.6895C195.074 77.6895 200.355 83.0228 200.355 89.6006C200.355 96.1783 195.074 101.512 188.546 101.512C182.019 101.512 176.738 96.1783 176.738 89.6006C176.738 83.0228 182.019 77.6895 188.546 77.6895Z",
    fill: "#0D0B0A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.978 81.1851C191.868 80.5333 193.648 81.4814 195.013 83.3185C196.378 85.1555 196.793 87.1703 195.903 87.8222C195.013 88.474 193.233 87.5259 191.868 85.6888C190.503 83.9111 190.088 81.837 190.978 81.1851Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.202 89.8369C197.211 89.8369 197.982 90.6665 197.982 91.6147C197.982 92.5628 197.211 93.3925 196.202 93.3925C195.193 93.3925 194.422 92.5628 194.422 91.6147C194.422 90.6665 195.193 89.8369 196.202 89.8369Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.112 107.378C123.215 107.378 127.369 109.333 127.369 111.763C127.369 114.193 123.215 116.148 118.112 116.148C113.009 116.148 108.855 114.193 108.855 111.763C108.855 109.333 113.009 107.378 118.112 107.378Z",
    fill: "#ED8181"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.018 107.378C214.121 107.378 218.275 109.333 218.275 111.763C218.275 114.193 214.121 116.148 209.018 116.148C203.915 116.148 199.762 114.193 199.762 111.763C199.762 109.333 203.915 107.378 209.018 107.378Z",
    fill: "#ED8181"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M189.379 36.5631C184.216 27.7927 178.757 21.5112 170.272 18.4298C170.154 18.3705 169.976 18.4298 169.857 18.5483C169.738 18.6668 169.738 18.8446 169.857 18.9631C170.628 20.1483 171.993 22.4001 173.536 25.4816C170.154 24.1187 159.532 12.3261 159.176 5.92606C159.176 5.74828 159.117 5.5705 158.939 5.51124C158.761 5.45198 158.583 5.45198 158.464 5.51124C156.031 8.29643 152.708 17.9557 154.845 25.2446C154.845 25.2446 148.021 23.5853 142.621 15.5261C142.443 15.289 142.206 15.1705 141.909 15.1705C141.612 15.1705 141.375 15.3483 141.256 15.5853C139.773 19.6149 141.375 29.7483 147.368 35.0816L189.379 36.5631Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 5,
    width: 50,
    height: 32
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M189.379 36.5631C184.216 27.7927 178.757 21.5112 170.272 18.4298C170.154 18.3705 169.976 18.4298 169.857 18.5483C169.738 18.6668 169.738 18.8446 169.857 18.9631C170.628 20.1483 171.993 22.4001 173.536 25.4816C170.154 24.1187 159.532 12.3261 159.176 5.92606C159.176 5.74828 159.117 5.5705 158.939 5.51124C158.761 5.45198 158.583 5.45198 158.464 5.51124C156.031 8.29643 152.708 17.9557 154.845 25.2446C154.845 25.2446 148.021 23.5853 142.621 15.5261C142.443 15.289 142.206 15.1705 141.909 15.1705C141.612 15.1705 141.375 15.3483 141.256 15.5853C139.773 19.6149 141.375 29.7483 147.368 35.0816L189.379 36.5631Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.383 17.8961C169.383 17.8961 169.621 18.2516 169.621 18.3109C169.917 18.7257 170.214 19.1998 170.511 19.6146C171.816 21.4516 173.3 23.2887 174.842 24.8887C175.317 25.3628 175.732 25.8368 176.207 26.2516C176.267 26.3109 176.623 26.6072 176.563 26.7257C176.385 26.9035 175.08 26.1924 174.902 26.1331C173.122 25.3035 171.638 24.1776 170.273 22.7554C167.841 20.1479 165.883 17.1257 164.102 14.0442C162.204 10.6665 160.423 6.87387 160.067 2.96276C160.067 2.84424 159.771 3.08128 159.711 3.08128C159.474 3.1998 159.237 3.37757 158.999 3.49609C158.406 3.91091 157.813 4.5035 157.279 5.03683C155.676 6.81461 154.43 9.0072 153.956 11.3776C153.184 15.4665 153.896 20.622 156.211 24.1183C157.635 26.2516 159.652 27.7924 161.848 28.9776C161.788 28.9183 161.432 28.8591 161.373 28.7998C160.898 28.622 160.483 28.4442 160.008 28.2665C158.465 27.6146 156.923 26.9035 155.498 26.0739C151.76 23.9405 149.031 20.9776 147.013 17.2442C147.073 17.3035 146.954 17.1257 146.895 17.0072C146.776 16.8887 146.717 16.7109 146.598 16.5331C146.361 16.1183 146.064 15.7035 145.827 15.2887C145.233 14.3405 144.106 11.8516 142.741 11.9702C141.97 12.0294 141.258 12.6813 140.783 13.2146C139.418 14.8146 139.003 17.2442 139.062 19.2591C139.121 21.2146 140.011 22.9331 140.961 24.6516C142.326 27.0813 143.809 29.5109 145.886 31.3479C146.954 32.3554 148.141 33.1257 149.446 33.8368C149.861 34.0739 150.277 34.3109 150.752 34.4887C150.811 34.4887 151.404 34.7257 151.404 34.785C151.345 34.8442 150.989 34.785 150.93 34.785C150.455 34.785 149.98 34.785 149.565 34.785C147.488 34.7257 145.47 34.2516 143.69 33.0665C140.249 30.8146 137.875 26.8442 136.214 23.1702C135.205 20.9183 134.434 18.4887 134.849 16.0591C136.273 7.11091 144.996 0.651649 153.718 0.059056C161.907 -0.474277 170.629 4.85906 171.223 13.6294L169.383 17.8961Z",
    fill: "#D0D0D0"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M144.4 150.992C143.747 150.933 143.035 151.17 142.56 151.644C142.085 152.118 141.848 152.77 141.907 153.481C143.331 163.733 152.351 171.674 163.269 171.674C174.187 171.674 183.265 163.733 184.63 153.481C184.69 152.829 184.512 152.178 184.037 151.703C183.562 151.229 182.909 150.992 182.257 151.052C173 151.703 153.597 151.703 144.4 150.992Z",
    fill: "#0D0B0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 150,
    width: 44,
    height: 22
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M144.4 150.992C143.747 150.933 143.035 151.17 142.56 151.644C142.085 152.118 141.848 152.77 141.907 153.481C143.331 163.733 152.351 171.674 163.269 171.674C174.187 171.674 183.265 163.733 184.63 153.481C184.69 152.829 184.512 152.178 184.037 151.703C183.562 151.229 182.909 150.992 182.257 151.052C173 151.703 153.597 151.703 144.4 150.992Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.92 162.192C174.304 162.192 182.73 170.607 182.73 181.037C182.73 191.407 174.304 199.881 163.92 199.881C153.536 199.881 145.11 191.466 145.11 181.037C145.05 170.607 153.536 162.192 163.92 162.192Z",
    fill: "#FF0010"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_198_190528",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 150,
    width: 44,
    height: 22
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M144.4 150.992C143.747 150.933 143.035 151.17 142.56 151.644C142.085 152.118 141.848 152.77 141.907 153.481C143.331 163.733 152.351 171.674 163.269 171.674C174.187 171.674 183.265 163.733 184.63 153.481C184.69 152.829 184.512 152.178 184.037 151.703C183.562 151.229 182.909 150.992 182.257 151.052C173 151.703 153.597 151.703 144.4 150.992Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_198_190528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.28 143.703H148.611C148.433 148.029 147.959 152.414 149.62 156.148C149.917 156.74 150.451 157.155 151.103 157.333C160.301 159.348 166.472 159.407 175.313 157.392C175.966 157.214 176.5 156.799 176.796 156.207C178.636 151.881 178.28 147.792 178.28 143.703Z",
    fill: "white"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M163.387 173.096C151.875 173.096 142.025 164.741 140.542 153.6C140.423 152.474 140.779 151.348 141.61 150.519C142.381 149.748 143.509 149.333 144.636 149.452C153.596 150.163 172.94 150.222 182.256 149.452C183.324 149.333 184.451 149.689 185.223 150.519C185.994 151.348 186.409 152.415 186.231 153.541C184.689 164.741 174.898 173.096 163.387 173.096ZM144.161 152.415C143.983 152.415 143.805 152.474 143.627 152.652C143.449 152.83 143.39 153.007 143.449 153.245C144.755 162.845 153.299 170.133 163.387 170.133C173.415 170.133 182.019 162.845 183.265 153.185C183.265 153.007 183.205 152.77 183.087 152.652C182.909 152.474 182.731 152.415 182.493 152.474C172.999 153.244 153.418 153.244 144.339 152.474H144.28C144.221 152.415 144.221 152.415 144.161 152.415Z",
    fill: "#0D0B0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_190528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 320,
    fill: "white",
    transform: "translate(44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZebraExcited);
export default __webpack_public_path__ + "static/media/zebra_excited.dc26661378fa62626c172f96919469bf.svg";
export { ForwardRef as ReactComponent };